import axios, { AxiosResponse } from 'axios';
import EnvWindow from '../../../utils/env';
import { AssessmentSessionProcessTypeId } from '../assessmentSession/assessments.types';

export async function getAvailableAssessmentSessionProcesses(): Promise<
  AxiosResponse<AssessmentSessionProcessTypeId[]>
> {
  return await axios.get(`${EnvWindow.REACT_APP_EXAMS_API_URL}/AssessmentSessionProcess/available`);
}
